import React, { useContext, useEffect } from 'react'
import ContactForm from '../Home/ContactForm'
import { DirectionContext } from '../Contexts/DirectionContext';
import { Trans } from 'react-i18next';
import WOW from 'wowjs';

export default function Contact() {
  const { dir } = useContext(DirectionContext)

  useEffect(() => {
    new WOW.WOW({
      live: true,
      mobile: false    
    }).init();
  }, []); 
  const TitleStyle = {
    borderRight: dir === 'rtl' ? '6px solid' : 'none',
    borderLeft: dir === 'ltr' ? '6px solid' : 'none',
  };
  return <>
    <div className="container-fluid PagesLyout">
      <section>
        <div className="row justify-content-center">
          <div className="col-md-11 text-center">
            <h1 className='Title  justify-content-center mb-3 wow fadeInLeft' data-wow-delay=".3s" >
              <Trans i18nKey="ContactPageTitle">تواصل معنا  </Trans></h1>
            <h3 className='mb-5  wow fadeIn' data-wow-delay="0.7s"><Trans i18nKey="ContactPageSubtitle">نحن هنا لمساعدتك – تواصل معنا للحصول على استشارتك القانونية المتخصصة.</Trans></h3>
          </div>
          <div className="col-md-6 ">
            <div className='headlineContainer'>
              <h2 className="Title px-2 my-5 wow fadeInLeft " data-wow-delay="1.0s" >
                <div className='indicator'></div>
              <Trans i18nKey="ContactInfoTitle">معلومات الاتصال</Trans></h2>
            </div>
            <div className="row align-items-baseline  wow fadeIn " data-wow-delay="1.2s" style={{ fontWeight: "600" }} >
              <div className="col-auto">
                <h4><i className="bi bi-telephone ContactPhonei px-3"></i><Trans i18nKey="ContactPhone">الجوال</Trans> </h4>
              </div>
              <div className="col-auto">
                <h4 className='contactData'>966557000907+</h4>
              </div>
            </div>
            <div className="row align-items-baseline wow fadeIn" data-wow-delay="1.5s" style={{ fontWeight: "600" }}>
              <div className="col-auto">
                <h4><i className="bi bi-envelope px-3"></i> <Trans i18nKey="ContactMail">البريد</Trans> </h4>
              </div>
              <div className="col-auto">
                <h4 className='contactData'>Info@AJL.sa</h4>
              </div>
            </div>
            <div className="row align-items-baseline  wow fadeIn" data-wow-delay="1.6s" style={{ fontWeight: "600" }}>
              <div className="col-md-12">
                <h4><i className="bi bi-clock px-3"></i> <Trans i18nKey="ContactWokingHours">مواعيد العمل </Trans> </h4>
              </div>
              <div className="col-md-12">
                <h4 className='contactData px-3'><Trans i18nKey="booking.officeTime">الأحد - الخميس</Trans></h4>
              </div>
              <div className="col-md-12">
                <h4 className='contactData px-3'><Trans i18nKey="Aboutus.WorkingHours">9:00صباحًا - 6:00 مساءً</Trans></h4>
              </div>
            </div>
          </div>
          <div className="col-md-5  wow fadeIn" data-wow-delay="1.0s">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3622800.2520244035!2d44.0883360279858!3d24.713551687460835!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f03890d489399%3A0xba974d1c98e79fd5!2sRiyadh%2C%20Saudi%20Arabia!5e0!3m2!1sen!2ssa!4v1710000000000"
              width="100%"
              height="450"
              allowFullScreen=""
              title="Abdullah Al Jasir Law Firm Legal Resources"
>
            </iframe>
          </div>
        </div>
      </section>
    </div>
    <div className='contactRow my-5 ContactCover'>
      <div className="container-fluid">
        <div className="row justify-content-evenly">
          <div className="col-md-11">
            <div className="row align-items-center justify-content-between py-5 ">
              <div className="col-md-6">
                <h2 className="Title px-2 my-5 wow fadeInLeft" data-wow-delay="0.3s" style={{color:"var(--bg)"}} ><Trans i18nKey="ContactFormTitle">أو املأ النموذج وسنعاود الاتصال بك قريبًا.</Trans> </h2>
              </div>
              <div className="col-md-6 col-xl-4">
                {/* نموذج التواصل */}
                <ContactForm />
                {/* نهاية نموذج التواصل */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
}
